import { generateHash, generateMinifiedQuery } from "../hash.js";
export const statsQuery = `query ($site: String!, $path: String, $pageId: String, $device: Device!, $includeContent: Boolean, $moduleLimit: Int, $moduleOffset: Int, $languageCode: String, $countryCode: String, $userState: String, $modules: [String!], $offset: Int) {
  page(
    site: $site
    path: $path
    pageId: $pageId,
    device: $device
    includeContent: $includeContent
    moduleLimit: $moduleLimit
    moduleOffset: $moduleOffset
    languageCode: $languageCode
    countryCode: $countryCode
    userState: $userState
    modules: $modules
    offset: $offset
  ) {
    id
    moduleCount
    moduleIds
    metadataMap {
      title
    }
    modules {
      id
      moduleType
      layout{
        settings
      }
      ... on SportRadarModule {
        id
        title
        moduleType  
        rawText
        setting{
          ...ModuleSettings
        }
        metadataMap
        layout {
          ...Layout
        }
      }
      
    }
  }
}

fragment ModuleSettings on ModuleSetting{
  hideDate
  hideTitle
  lazyLoad
  seeAll
  seeAllCard
  showMore
  seeAllPermalink
  showMoreCta
}

fragment Layout on ModuleLayout {
  id
  settings
  styles
  view
  type
  blockName
  isMasthead
}`

export const minifiedstatsPageQuery=generateMinifiedQuery(statsQuery);
export const statsPageQuerySHA =  generateHash(minifiedstatsPageQuery);




